import ProfileCountryModel from "./ProfileCountryModel";
import InterestModel from "./InterestModel";

export default class ProfileModel {
    public id: string = null;
    public name: string | null = null;
    public nickname: string | null = null;
    public avatar: string | null = null;
    public gender: string | null = null;
    public country: ProfileCountryModel | null = null;
    public birthDate: string | null = null;
    public verified: boolean = false;
    public staffMember: boolean = false;
    public anonymous: boolean = false;
    public disabled: boolean = false;
    public interests: InterestModel[] = [];
    public followingCount: number = 0;
    public followersCount: number = 0;
}
